import client from 'core/axios';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getInNetworkCollege = ({ heSchool, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/transmissions/colleges/${heSchool}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse);

export default {
  getInNetworkCollege,
};
